module.exports = __webpack_public_path__ + "../resources/images/fileType_sprite-ccc7d85c596b47b4ce53b77a4e40cd4f.png";